<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div class="rn-page-title-area pt--120 pb--190 banner-blog-details-notin" data-black-overlay="5" :style="{ backgroundImage: 'url(' + imagenIDtoSRC(Articulo.Imagen) + ')' }">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="banner-blog-details-notin text-center pt--100">
              <h1 class="heading-title">
                {{ Articulo.Titulo }}
              </h1>
              <p v-if="Articulo.Subtitulo">{{ Articulo.Subtitulo }}</p>
              <ul class="blog-meta d-flex justify-center align-center">
                <li class="d-flex">
                  <span v-html="iconSvg('clock')"></span><span>{{ date }}</span>
                </li>
                <li class="d-flex" v-if="Articulo.Autor">
                  <span v-html="iconSvg('user')"></span><span>{{ Articulo.Autor }}</span>
                </li>
                <li class="d-flex" v-if="Articulo.PermitirComentarios">
                  <span v-html="iconSvg('message-circle')"></span><span>{{ Articulo.Comentarios.length }}
                    Comentarios</span>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <!-- Start Blog Details Area  -->
    <div class="rn-blog-details pt--110 pb--70 bg_color--1 content-blog-details-notin">
      <v-container>
        <v-row>
          <v-col cols="12">
            <!-- <div class="thumb">
              <img class="w-100" :src="imagenIDtoSRC(Articulo.Imagen)"
                :alt="'Imagen de la entrada: ' + Articulo.Titulo" />
            </div> -->
            <div class="content">
              <div class="text-justify">
                <p v-thtml="Articulo.Contenido"></p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Blog Details Area  -->
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import feather from "feather-icons";
import { useStore } from '../store/index.ts'
import { useRoute } from 'vue-router';
const store = useStore()
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
const route = useRoute()
const Articulo = ref(Object)
const date = ref(String)
const formData = reactive({
  name: "",
  email: "",
  subject: "",
  message: "",
})


import { useStyles } from '../../store/styles';
const style = useStyles();
const blog = style.ThemeSectionBlog
// const blogTitulo = ref({
var  blogTitulocolor = blog.Titulo.css.Color;
var  blogTituloshadows = blog.Titulo.css.BackgroundColor ? "4px 2px 6px "+ blog.Titulo.css.BackgroundColor:"";
var  blogTitulofontFamily = blog.Titulo.css.Font;
var  blogTitulosize = blog.Titulo.css.Size;
var  blogTitulofontWeight = blog.Titulo.css.Weight;
var  blogTituloalign = blog.Titulo.css.Align;
// })

// const blogSubtitulo = ref({
var blogSubtitulocolor = blog.Subtitulo.css.Color;
var blogSubtituloshadows = blog.Subtitulo.css.BackgroundColor ? "4px 2px 6px "+ blog.Subtitulo.css.BackgroundColor:"";
var blogSubtitulofontFamily = blog.Subtitulo.css.Font;
var blogSubtitulosize = blog.Subtitulo.css.Size;
var blogSubtitulofontWeight = blog.Subtitulo.css.Weight;
var blogSubtituloalign = blog.Subtitulo.css.Alig;
// })

// const blogButton = ref({
var blogButtoncolor = blog.Button.css.Color
var blogButtonbackgroundColor = blog.Button.css.BackgroundColor
var blogButtonfontFamily = blog.Button.css.Font;
var blogButtonfontWeight = blog.Button.css.Weight;
var blogButtonborder = blog.Button.css.Color??  "2px solid" + blog.Button.css.Color
// })

const imgFiltro = blog?.ImagenFiltro ? blog.ImagenFiltro : ""
const img = blog.Imagen ? "url(" + imagenIDtoSRC(blog.Imagen)+ ")" : ""

var blogTarjetaTitulocolor = blog.Tarjeta.Titulo.css.Color
var blogTarjetaTituloshadows = blog.Tarjeta.Titulo.css.BackgroundColor ? "4px 2px 6px "+ blog.Tarjeta.Titulo.css.BackgroundColor:""
var blogTarjetaTitulofontFamily = blog.Tarjeta.Titulo.css.Font
var blogTarjetaTitulosize = blog.Tarjeta.Titulo.css.Size
var blogTarjetaTitulofontWeight = blog.Tarjeta.Titulo.css.Weight
var blogTarjetaTituloalign = blog.Tarjeta.Titulo.css.Align

var blogTarjetaDescripcioncolor = blog.Tarjeta.Descripcion.css.Color
var blogTarjetaDescripcionshadows = blog.Tarjeta.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ blog.Tarjeta.Descripcion.css.BackgroundColor:""
var blogTarjetaDescripcionfontFamily = blog.Tarjeta.Descripcion.css.Font
var blogTarjetaDescripcionsize = blog.Tarjeta.Descripcion.css.Size
var blogTarjetaDescripcionfontWeight = blog.Tarjeta.Descripcion.css.Weight
var blogTarjetaDescripcionalign = blog.Tarjeta.Descripcion.css.Align
var blogTarjetaDescripcionbackground = blog.Tarjeta.Descripcion.css.BackgroundColor
var blogTarjetaDescripcionborder = blog.Tarjeta.Descripcion.css.Color??  "2px solid" + blog.Tarjeta.Descripcion.css.Color 

const blogTarjetaFondo = ref("linear-gradient(to bottom," + blog.Tarjeta.FondoCSS.BackgroundColor +" 0,"+ blog.Tarjeta.FondoCSS.BackgroundColorGradient+" 100%)")


var blogDetallesTituloBannercolor= blog.Detalles.TituloBannerCSS.Color
var blogDetallesTituloBannershadows= blog.Detalles.TituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.TituloBannerCSS.BackgroundColor:""
var blogDetallesTituloBannerfontFamily=blog.Detalles.TituloBannerCSS.Font
var blogDetallesTituloBannersize = blog.Detalles.TituloBannerCSS.Size
var blogDetallesTituloBannerfontWeight=blog.Detalles.TituloBannerCSS.Weight
var blogDetallesTituloBanneralign=blog.Detalles.TituloBannerCSS.Align

var blogDetallesSubtituloBannercolor = blog.Detalles.SubtituloBannerCSS.Color
var blogDetallesSubtituloBannershadows = blog.Detalles.SubtituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.SubtituloBannerCSS.BackgroundColor:""
var blogDetallesSubtituloBannerfontFamily = blog.Detalles.SubtituloBannerCSS.Font
var blogDetallesSubtituloBannersize=blog.Detalles.SubtituloBannerCSS.Size
var blogDetallesSubtituloBannerfontWeight = blog.Detalles.SubtituloBannerCSS.Weight
var blogDetallesSubtituloBanneralign = blog.Detalles.SubtituloBannerCSS.Align

var blogDetallesH1color = blog.Detalles.H1.Color
var blogDetallesH1shadows = blog.Detalles.H1.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H1.BackgroundColor:""
var blogDetallesH1fontFamily = blog.Detalles.H1.Font
var blogDetallesH1size =blog.Detalles.H1.Size
var blogDetallesH1fontWeight = blog.Detalles.H1.Weight
var blogDetallesH1align = blog.Detalles.H1.Align

var blogDetallesH2color = blog.Detalles.H2.Color
var blogDetallesH2shadows = blog.Detalles.H2.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H2.BackgroundColor:""
var blogDetallesH2fontFamily = blog.Detalles.H2.Font
var blogDetallesH2size=blog.Detalles.H2.Size
var blogDetallesH2fontWeight=blog.Detalles.H2.Weight
var blogDetallesH2align=blog.Detalles.H2.Align

var blogDetallesH3Acolor = blog.Detalles.H3.Color
var blogDetallesH3Ashadows = blog.Detalles.H3.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.H3.BackgroundColor:""
var blogDetallesH3AfontFamily = blog.Detalles.H3.Font
var blogDetallesH3Asize = blog.Detalles.H3.Size
var blogDetallesH3AfontWeight = blog.Detalles.H3.Weight
var blogDetallesH3Aalign = blog.Detalles.H3.Align

var blogDetallesPcolor = blog.Detalles.p.Color
var blogDetallesPshadows = blog.Detalles.p.BackgroundColor ? "4px 2px 6px "+ blog.Detalles.p.BackgroundColor:""
var blogDetallesPfontFamily = blog.Detalles.p.Font
var blogDetallesPsize = blog.Detalles.p.Size
var blogDetallesPfontWeight = blog.Detalles.p.Weight
var blogDetallesPalign = blog.Detalles.p.Align
const blogDetallesFondo = ref("linear-gradient(to bottom," + blog.Detalles.FondoBannerCSS.BackgroundColor +" 0,"+ blog.Detalles.FondoBannerCSS.BackgroundColorGradient+" 100%)")


var slug:string = route.params.id.toString()
Articulo.value = store.NOTARIA.Blog.find(x => x.Slug === slug);

if (!Articulo)
  route.push("/404")
else if (!Articulo.value?.Publicado)
  route.push("/404")
else
  date.value = Articulo.value.Fecha

function iconSvg(icon) {
  return feather.icons[icon].toSvg();
}
function onSubmit() {
  ////console.log(this.formData);
}
const PageName = "Blog"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName,slug)
</script>


<style lang="scss">
.banner-blog-notin-bg-1{
  background-image:v-bind(img);

}
.banner-blog-notin-filter-1{
  -webkit-backdrop-filter: v-bind(imgFiltro);
  backdrop-filter:v-bind(imgFiltro) ;
}

.banner-blog-notin h1{
  color:v-bind(blogTitulocolor);
  text-shadow:v-bind(blogTituloshadows);
  font-family:v-bind(blogTitulofontFamily);
  font-size:v-bind(blogTitulosize);
  font-weight:v-bind(blogTitulofontWeight);
  text-align:v-bind(blogTituloalign);
}

.banner-blog-notin h2, .banner-blog-notin h3{
  color:v-bind(blogSubtitulocolor);
  text-shadow:v-bind(blogSubtituloshadows);
  font-family:v-bind(blogSubtitulofontFamily);
  font-size:v-bind(blogSubtitulosize);
  font-weight:v-bind(blogSubtitulofontWeight);
  text-align:v-bind(blogSubtituloalign);
}

.banner-blog-notin a, .banner-blog-notin button{
  color:v-bind(blogButtoncolor);
  background-color:v-bind(blogButtonbackgroundColor);
  font-family:v-bind(blogButtonfontFamily);
  font-weight:v-bind(blogButtonfontWeight);
  border:v-bind(blogButtonborder);
}
.card-blog-notin h3, .card-blog-notin h5{
  color:v-bind(blogTarjetaTitulocolor);
  text-shadow:v-bind(blogTarjetaTituloshadows);
  font-family:v-bind(blogTarjetaTitulofontFamily);
  font-size:v-bind(blogTarjetaTitulosize);
  font-weight:v-bind(blogTarjetaTitulofontWeight);
  text-align:v-bind(blogTarjetaTituloalign);
}
.card-blog-notin p{
  color:v-bind(blogTarjetaDescripcioncolor);
  text-shadow:v-bind(blogTarjetaDescripcionshadows);
  font-family:v-bind(blogTarjetaDescripcionfontFamily);
  // font-size:v-bind(blogTarjetaDescripcion.size);
  font-weight:v-bind(blogTarjetaDescripcionfontWeight);
  text-align:v-bind(blogTarjetaDescripcionalign);
}
.card-blog-notin a{
  color:v-bind(blogTarjetaTitulocolor);
}
.card-blog-notin a:after{
  background:v-bind(blogTarjetaFondo)
}
.card-blog-notin a.rn-btn-notin, .card-blog-notin button.rn-btn-notin{
  color:v-bind(blogTarjetaDescripcioncolor);
  font-family:v-bind(blogTarjetaDescripcionfontFamily);
  // font-size:v-bind(blogTarjetaDescripcion.size);
  font-weight:v-bind(blogTarjetaDescripcionfontWeight);
  background:v-bind(blogTarjetaDescripcionbackground);
  border:v-bind(blogTarjetaDescripcionborder)
}
.banner-blog-details-notin h1, .banner-blog-details-notin h2{
  color:v-bind(blogDetallesTituloBannercolor);
  text-shadow:v-bind(blogDetallesTituloBannershadows);
  font-family:v-bind(blogDetallesTituloBannerfontFamily);
  font-size:v-bind(blogDetallesTituloBannersize);
  font-weight:v-bind(blogDetallesTituloBannerfontWeight);
  text-align:v-bind(blogDetallesTituloBanneralign);
}
.banner-blog-details-notin span{
  color:v-bind(blogDetallesSubtituloBannercolor);
  text-shadow:v-bind(blogDetallesSubtituloBannershadows);
  font-family:v-bind(blogDetallesSubtituloBannerfontFamily);
  // font-size:v-bind(blogDetallesSubtituloBannersize);
  font-weight:v-bind(blogDetallesSubtituloBannerfontWeight);
  text-align:v-bind(blogDetallesSubtituloBanneralign);
}
.content-blog-details-notin h1{
  color:v-bind(blogDetallesH1color);
  text-shadow:v-bind(blogDetallesH1shadows);
  font-family:v-bind(blogDetallesH1fontFamily);
  font-size:v-bind(blogDetallesH1size);
  font-weight:v-bind(blogDetallesH1fontWeight);
  text-align:v-bind(blogDetallesH1align);
}
.content-blog-details-notin h2{
  color:v-bind(blogDetallesH2color);
  text-shadow:v-bind(blogDetallesH2shadows);
  font-family:v-bind(blogDetallesH2fontFamily);
  // font-size:v-bind(blogDetallesH2size);
  font-weight:v-bind(blogDetallesH2fontWeight);
  text-align:v-bind(blogDetallesH2align);
}
.content-blog-details-notin h3, .content-blog-details-notin a{
  color:v-bind(blogDetallesH3Acolor);
  text-shadow:v-bind(blogDetallesH3Ashadows);
  font-family:v-bind(blogDetallesH3AfontFamily);
  font-size:v-bind(blogDetallesH3Asize);
  font-weight:v-bind(blogDetallesH3AfontWeight);
  text-align:v-bind(blogDetallesH3Aalign);
}
.content-blog-details-notin p{
  color:v-bind(blogDetallesPcolor);
  text-shadow:v-bind(blogDetallesPshadows);
  font-family:v-bind(blogDetallesPfontFamily);
  // font-size:v-bind(blogDetallesPsize);
  font-weight:v-bind(blogDetallesPfontWeight);
  text-align:v-bind(blogDetallesPalign);
}
.banner-blog-details-notin{
  background: v-bind(blogDetallesFondo)
}

</style>